export default __webpack_public_path__ + "assets/moon-waning-crescent.d4ab139a.svg";